import _objectSpread from "D:/project/e-his\u968F\u8BBF\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import * as echarts from "echarts";
import { isEmpty } from "@/utils/shared";
export default {
  name: "EvalidateCycle",
  props: ["source", "id"],
  watch: {
    source: function source() {
      this.init();
    },
    id: function id() {
      this.echart && this.echart.resize();
    }
  },
  data: function data() {
    return {
      echart: null,
      idx: 0,
      timer: null
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.init();
    this.timer = setInterval(function () {
      if (_this.echart) {
        _this.echart.dispatchAction({
          type: "downplay",
          dataIndex: _this.idx
        });
        _this.idx++;
        if (_this.idx > 3) {
          _this.idx = 0;
        }
        _this.echart.dispatchAction({
          type: "highlight",
          dataIndex: _this.idx
        });
      }
    }, 2000);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    init: function init() {
      var _this2 = this;
      if (isEmpty(this.echart)) {
        this.echart = echarts.init(document.getElementById("evalidateCycle"));
      }
      var echart = this.echart;
      var color = "#F9FAFA";
      echart.setOption({
        color: ["#578EC7", "#D9975D", "#819CB2", "#FCD695"],
        legend: {
          top: "10%",
          right: "10%",
          orient: "vertical",
          itemHeight: this.size(14),
          itemWidth: this.size(14),
          itemGap: parseInt(this.size(16)),
          textStyle: {
            fontSize: this.size(12),
            color: color,
            padding: [0, 0, 0, this.size(4)]
          }
        },
        series: {
          name: "Nightingale Chart",
          type: "pie",
          radius: ["10%", "80%"],
          center: ["40%", "50%"],
          roseType: "area",
          itemStyle: {
            borderRadius: 8
          },
          label: {
            color: color,
            fontSize: this.size(12)
          },
          labelLine: {
            lineStyle: {
              width: this.size(1)
            }
          },
          data: [{
            name: "每周/次",
            value: 93,
            key: "weekNum"
          }, {
            name: "每月/次",
            value: 32,
            key: "monthNum"
          }, {
            name: "3月/次",
            value: 65,
            key: "threeNum"
          }, {
            name: "半年/次",
            value: 44,
            key: "yearNum"
          }].map(function (it) {
            return _objectSpread(_objectSpread({}, it), {}, {
              value: _this2.source[it.key] || 0
            });
          })
        }
      });
    },
    size: function size(sz) {
      return sz / 14 * document.documentElement.style.fontSize.slice(0, -2);
    }
  }
};